// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2FRmz","content":"styles_content__1bGjv","checkbox":"styles_checkbox__2wUVD","checkboxLabel":"styles_checkboxLabel__-1hXB"};